import React from "react";

const NextBlogIcon = () => (
    <svg width="24" height="24" role="presentation" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.9461 11.4094L7.38047 3.15709C7.35286 3.13536 7.31968 3.12185 7.28474 3.11812C7.2498 3.11439 7.21452 3.12059 7.18295 3.13601C7.15137 3.15143 7.12479 3.17544 7.10625 3.20529C7.08771 3.23514 7.07796 3.26961 7.07813 3.30475V5.11647C7.07813 5.23131 7.13203 5.34147 7.2211 5.41178L15.6586 12.0001L7.2211 18.5883C7.12969 18.6587 7.07813 18.7688 7.07813 18.8837V20.6954C7.07813 20.8524 7.2586 20.9391 7.38047 20.843L17.9461 12.5907C18.0359 12.5206 18.1085 12.431 18.1585 12.3287C18.2084 12.2263 18.2344 12.114 18.2344 12.0001C18.2344 11.8862 18.2084 11.7738 18.1585 11.6714C18.1085 11.5691 18.0359 11.4795 17.9461 11.4094Z" fill="#262626"/>
    </svg>
);

export default NextBlogIcon;
